<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>{{ $t("text.cUsers.subTitle") }} ({{ $route.query.username }})</p>
      </div>
      <div class="cover">
        <div class="row">
          <div
            class="input__group__block mt-4 ml-3"
            style="width: 50%; margin: 0"
          >
            <label class="required">
              <span class="mylabel"> {{ $t("text.cUsers.selectGrp") }} </span>
            </label>
            <div class="price_change_input_wrapper">
              <select v-model="groupId">
                <option value="select group" disabled selected>
                  {{ $t("text.cUsers.selectGrp") }}
                </option>
                <option :value="group.id" v-for="(group, i) in groups" :key="i">
                  {{ group.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="mt-4" v-if="!groupRolesLoader">
            <label> {{ $t("text.cUsers.availableRoles") }}</label>
            <div class="price_change_input_wrapper">
              <div @click="toggleBranchListDropdown" style="padding: 5px">
                <vue-tags-input
                  v-model="tag"
                  :tags="tags"
                  @tags-changed="(newTags) => (tags = newTags)"
                />
              </div>

              <div class="">
                <div class="search__wrapper">
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <input
                        type="text"
                        :placeholder="$t('text.iUsers.search')"
                        v-model="searchInp"
                        name="search"
                      />
                    </div>
                    <div class="col-md-2 text-right">
                      <i
                        class="fa fa-search mr-3"
                        aria-hidden="true"
                        style="color: #b6b6b6"
                      ></i>
                    </div>
                  </div>
                </div>
                <!-- <div class="row mt-3" style="width: 100%; margin: 0 auto">
                  <div class="col-md-4">
                    <div class="d-flex align-items-center" styl="height:50px">
                      <input
                        type="checkbox"
                        class="mr-2"
                        @click="checkAll"
                        id="selectAllCheckbox"
                      />
                      <span class="primary-color">Select All Roles</span>
                    </div>
                  </div>
                </div> -->
                <div
                  class="row justify-content-center mt-3"
                  style="width: 100%; margin: 0 auto"
                >
                  <div class="col-md-4">
                    <div class="">
                      <b-form-group
                        label=""
                        v-on:click.native="toggleChckBox($event)"
                      >
                        <b-form-checkbox-group
                          v-model="selected"
                          :options="filteredList"
                          name="flavour-2a"
                          stacked
                        >
                        </b-form-checkbox-group>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                      label=""
                      v-on:click.native="toggleChckBox($event)"
                    >
                      <b-form-checkbox-group
                        v-model="selected"
                        :options="filteredList2"
                        name="flavour-2a"
                        stacked
                      >
                      </b-form-checkbox-group>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                      label=""
                      v-on:click.native="toggleChckBox($event)"
                    >
                      <b-form-checkbox-group
                        v-model="selected"
                        :options="filteredList3"
                        name="flavour-2a"
                        stacked
                      >
                      </b-form-checkbox-group>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <pulse-loader
            size="15px"
            v-if="groupRolesLoader"
            class="py-5"
          ></pulse-loader>
        </div>
        <div class="text-center mt-4 pb-4">
          <button
            :disabled="isButtonDisabled"
            class="ep-btn ep-primary"
            @click="mapRoles($event)"
          >
            Add roles
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "AddStaff",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      phoneNumber: null,
      email: null,
      isButtonDisabled: false,
      showLoader: true,
      backgroundUrl,
      role: "selectRole",
      branches: [],
      branch: "selectBranch",
      groups: [],
      groupId: "select group",
      groupRoles: [],
      company: null,
      options: [],
      options2: [],
      options3: [],
      selected: [],
      combinedOptions: [],
      tag: "",
      tags: [],
      searchInp: "",
      showRoles: false,
      forcePasswordChange: false,
      groupRolesLoader: false,
      selectAll: false,
      selectAllCheckbox: false,
      categories: [],
      categoryId: "select functional level",
      stage: "addUser",
      username: null,
      allRoles: [],

      rolesCategory: null,
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getRoleGroups();
        this.getRoleCategories();
        this.getUserRoles();
        this.getAllRoles();
      }
    },
    selectAll(value) {
      let selected = [];
      let combinedArray = [...this.options, ...this.options2, ...this.options3];
      if (!value) {
        this.selected = selected;
        this.tags = selected;
        return;
      }
      if (value) {
        combinedArray.forEach(function (opt) {
          selected.push(opt.text);
        });
        this.selected = selected;
        this.tags = selected;
      }
    },
    groupId() {
      if (this.$route.query.rolesCategory == "N/A") {
        this.getGroupRoles();
        return;
      }
      this.getGroupRoles();

      this.selected = [];
    },
    tags: {
      handler(newTags, oldTags) {
        let newSelectedArray = [];
        try {
          if (newTags[0].tiClasses) {
            newTags.forEach((tg) => {
              newSelectedArray.push(tg.text);
            });
          } else {
            newTags.forEach((tg) => {
              newSelectedArray.push(tg);
            });
          }
          if (newTags.length < 1) {
            newSelectedArray = [];
          }
        } catch {
          newSelectedArray = [];
        }
        this.selected = newSelectedArray;
      },
    },
    deep: true,
  },
  computed: {
    userName() {
      return `${this.userDetails.firstName} ${this.userDetails.lastName}`;
    },
    filteredList() {
      const sortedList = [...this.options];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList2() {
      const sortedList = [...this.options2];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList3() {
      const sortedList = [...this.options3];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getRoleGroups();
      this.getRoleCategories();
      this.getUserRoles();
      this.getAllRoles();
    }
    document.title = "Create User:: Epump Company";
  },
  mounted() {
    if (this.$route.query.username) {
      this.username = this.$route.query.username;
    }
    if (this.$route.query.rolesCategory) {
      if (this.$route.query.rolesCategory == "N/A") {
        this.rolesCategory = "";
      } else {
        this.rolesCategory = this.$route.query.rolesCategory;
      }
    }
  },
  beforeDestroy() {},
  methods: {
    nextStage($event) {
      $event.preventDefault();
      this.stage = "mapRoles";
    },
    getRoleCategories() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/Categories`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.categories = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getAllRoles() {
      this.showLoader = true;
      this.axios
        .get(`${configObject.apiBaseUrl}/Role`, configObject.authConfig())
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.allRoles = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    checkAll(e) {
      let selected = [];
      if (e.target.checked) {
        this.combinedOptions.forEach((el) => {
          selected.push(el.text);
        });
      }
      this.selected = selected;
      this.tags = selected;
    },
    toggleBranchListDropdown() {
      this.showBranchListDropDown = !this.showBranchListDropDown;
    },
    toggleChckBox($event) {
      if ($event.target.checked) {
        const getIndex = this.selected.indexOf($event.target.value);

        if (getIndex === -1) {
          this.selected.push($event.target.value);
          //   this.tags.push($event.target.value)
        }
      } else {
        // document.querySelector("#selectAllCheckbox").checked = false
        const getIndex = this.selected.indexOf($event.target.value);
        if (getIndex > -1) {
          this.selected.splice(getIndex, 1);
          //   this.tags.splice(getIndex, 1);
        }
      }
      if (this.selected.length == this.combinedOptions.length) {
        // document.querySelector("#selectAllCheckbox").checked = true
      }
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    getUserRoles() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/UserRoleCategoryRoles/${this.$route.query.username}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          res.data.forEach((el) => {
            el.text = el.name;
            el.value = el.name;
          });
          let copiedResponse = [...res.data];
          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });

          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.combinedOptions = [...options, ...options2, ...options3];
          this.combinedOptions.forEach((el) => {
            this.selected.push(el.name);
          });
          // this.disableSelectAll = true
          // document.querySelector("#selectAllCheckbox").checked = true
          this.roles = res.data;
        })
        .catch((error) => {});
    },
    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.branches = res.data;
        })
        .catch((error) => {});
    },
    getRoleGroups() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/Groups/${this.rolesCategory}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.groupId = res.data[0].id;
          this.groups = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getGroupRoles() {
      this.groupRolesLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}​/Role/GroupRoles/${this.groupId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showRoles = true;
          this.groupRolesLoader = false;
          res.data.forEach((el) => {
            el.text = el.name;
            el.value = el.name;
          });
          let copiedResponse = [...res.data];
          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });

          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.combinedOptions = [...options, ...options2, ...options3];
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    mapRoles($event) {
      $event.preventDefault();
      if (this.groupId == "select group") {
        this.$toast.open({
          message: "Please select a role group",
          type: "error",
          duration: 3000,
        });
        return;
      }

      let roleIds = [];
      this.combinedOptions.forEach((opt) => {
        if (this.selected.includes(opt.value)) {
          roleIds.push(opt.id);
        }
      });

      let data = {
        email: this.$route.query.username,
        role: this.groupId,
        roles: roleIds,
        branchId: null,
      };

      // return

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/AddUserToRole/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: `Successfully mapped roles to user (${this.username})`,
            type: "success",
            duration: 5000,
          });
          this.$router.push({ name: "company_users" });

          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
